import { render, staticRenderFns } from "./DownloadExport.vue?vue&type=template&id=1063ad8a&"
import script from "./DownloadExport.vue?vue&type=script&lang=js&"
export * from "./DownloadExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports